import React, { useEffect, useState } from 'react';
import { useBrandContext } from 'context/BrandProvider';

const AbstractBackground = () => {
  const { brand } = useBrandContext();
  const [src, setSrc] = useState<string | null>(null);

  useEffect(() => {
    const key = brand?.lpBackgroundImage || 'abstract_1';
    import(`assets/images/white-label/${key}.svg`)
      .then((module) => setSrc(module.default))
      .catch(() => {
        import('assets/images/white-label/abstract_1.svg').then((m) =>
          setSrc(m.default),
        );
      });
  }, [brand?.lpBackgroundImage]);

  if (!src) return null;

  return (
    <img
      src={src}
      alt="background"
      className="pointer-events-none absolute inset-0 h-full w-full object-cover object-right lg:object-contain"
    />
  );
};

export default AbstractBackground;
